module.exports = __webpack_public_path__ + "static/windgeist-cbc6909a2e794ea2978b8f5d706fd914.png";